import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight, Camera } from "lucide-react";
import { fmtPrice, fmtKm } from "@/lib/company";
import VehicleImage from "@/components/VehicleImage";

export const specLine = (v) =>
  [v.first_registration || v.year, fmtKm(v.mileage), v.power_ps ? `${v.power_ps} PS` : null, v.fuel?.split(" ")[0]]
    .filter(Boolean);

export const VehicleCard = ({ vehicle: v }) => {
  const photos = v.images?.length || 0;
  return (
    <Link to={`/fahrzeuge/${v.id}`} data-testid={`vehicle-card-${v.id}`}
      className="group card-lift card-soft block rounded-2xl overflow-hidden bg-surface">
      <div className="img-hover-zoom relative overflow-hidden aspect-[4/3] bg-elevated">
        <VehicleImage vehicle={v} size="card" />
        <div className="absolute top-4 left-4 flex flex-wrap gap-2">
          {v.is_new_arrival && (
            <span data-testid={`vehicle-card-new-${v.id}`} className="px-3 py-1.5 rounded-full text-[11px] font-semibold bg-brand text-white shadow-[0_6px_18px_-6px_rgba(200,16,46,0.7)]">
              Neu eingetroffen
            </span>
          )}
          {v.condition === "Neu" && <span className="px-3 py-1.5 rounded-full text-[11px] font-semibold bg-black/75 text-white backdrop-blur-md">Neufahrzeug</span>}
        </div>
        {photos > 1 && (
          <span data-testid={`vehicle-card-photos-${v.id}`}
            className="absolute bottom-3 right-3 inline-flex items-center gap-1.5 rounded-full bg-black/55 backdrop-blur-md text-white text-[11px] font-semibold px-2.5 py-1">
            <Camera size={12} /> {photos}
          </span>
        )}
      </div>
      <div className="p-6">
        <p className="text-[11px] uppercase tracking-[0.2em] text-faint font-semibold">{v.brand}</p>
        <h3 className="font-display font-bold text-lg text-ink mt-1 leading-snug line-clamp-2 min-h-[2.75rem] group-hover:opacity-70 transition-opacity duration-300">
          {v.title}
        </h3>
        <p className="text-sm text-dim mt-2 truncate">{specLine(v).join(" · ")}</p>
        <div className="flex items-end justify-between gap-3 mt-5 pt-4 border-t border-line">
          <div>
            <span className="font-display font-bold text-xl text-ink" data-testid={`vehicle-card-price-${v.id}`}>{fmtPrice(v.price)}</span>
            {v.vat_deductible && <p className="text-[11px] text-faint mt-0.5">MwSt. ausweisbar</p>}
          </div>
          <span className="flex items-center justify-center w-10 h-10 rounded-full border border-line text-dim transition-colors duration-300 group-hover:bg-action group-hover:border-action group-hover:text-action-ink">
            <ArrowUpRight size={17} />
          </span>
        </div>
      </div>
    </Link>
  );
};

export default VehicleCard;
